import { IContainerItem } from '../common/ContainerSchemas';
import {
  Button,
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Input,
  Spinner,
} from '@fluentui/react-components';
import React, { useEffect, useState } from 'react';

export interface IRenameDialogProps {
  newName: string;
  showRenameDialog: boolean;
  showRenamingSpinner: boolean;
  selectedItem: IContainerItem;
  onItemsUpdated: () => void;
  renameItem: (newName: string) => void;
  closeRenameModal: () => void;
}

export const RenameDialog: React.FunctionComponent<IRenameDialogProps> = (
  props: IRenameDialogProps,
) => {
  const [newName, setNewName] = useState<string>(props.newName);

  useEffect(() => {
    setNewName(props.newName);
  }, [props.newName]);

  return (
    <Dialog open={props.showRenameDialog}>
      <DialogSurface>
        {!props.showRenamingSpinner && (
          <DialogBody className="kt-ui-app dialog-content">
            <DialogTitle>Rename</DialogTitle>
            <DialogContent>
              <Input
                placeholder="New name"
                id="newName"
                aria-label="newName"
                type="text"
                name="newName"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button
                appearance="primary"
                onClick={() => props.renameItem(newName)}
                data-testid="rename-button"
              >
                Rename
              </Button>
              <Button
                appearance="secondary"
                onClick={() => props.closeRenameModal()}
              >
                Cancel
              </Button>
            </DialogActions>
          </DialogBody>
        )}
        {props.showRenamingSpinner && (
          <>
            <Spinner label="Renaming..." />
          </>
        )}
      </DialogSurface>
    </Dialog>
  );
};
